// src/app/features/trade/useTradeRequests.js
import { useQuery } from "@tanstack/react-query";
import { getTradeRequests } from "./tradeApi.js";

export function useTradeRequests({ limit = 10, offset = 0, status } = {}) {
  const normalizedStatus = String(status || "").toUpperCase();
  const isPending = normalizedStatus === "PENDING";

  return useQuery({
    queryKey: ["tradeRequests", { limit, offset, status: normalizedStatus }],
    queryFn: () =>
      getTradeRequests({
        limit,
        offset,
        status: normalizedStatus || undefined,
      }),
    keepPreviousData: true,
    staleTime: 5_000,
    refetchInterval: isPending ? 5_000 : false,
    refetchIntervalInBackground: true,
  });
}
